import type { Tealium } from 'src/types/appState';
import type { TealiumEventData, TealiumEvent } from 'src/types/trackingData';

import { getViewEventDataFromState } from './utils/getViewEventDataByPage/getViewEventDataByPage';
import { sendUtagLinkEvent } from './utils/sendUtagLinkEvent';

export default (
  tealium: Tealium,
  eventData: TealiumEventData | TealiumEvent,
) => {
  const pageViewEventData = getViewEventDataFromState(tealium);
  const utagData = {
    ...pageViewEventData,
    ...eventData,
  };
  sendUtagLinkEvent(eventData.eventType ?? eventData.eventName, utagData);
};
